export default __webpack_public_path__ + "static/media/background.a92a393c.png";